export type Port = {
  id: number
  name: string
  countryId: number
}

export const ports: Port[] = [
  { id: 1, countryId: 3, name: 'Durres' },
  { id: 2, countryId: 3, name: 'Sarande' },
  { id: 3, countryId: 3, name: 'Shengjin' },
  { id: 4, countryId: 3, name: 'Vlore' },
  { id: 5, countryId: 4, name: 'Algiers' },
  { id: 6, countryId: 4, name: 'Annaba' },
  { id: 7, countryId: 4, name: 'Arzew' },
  { id: 8, countryId: 4, name: 'Bejaia' },
  { id: 9, countryId: 4, name: 'Djendjene' },
  { id: 10, countryId: 4, name: 'Jijel' },
  { id: 11, countryId: 4, name: 'Mostaganem' },
  { id: 12, countryId: 4, name: 'Oran' },
  { id: 13, countryId: 4, name: 'Skikda' },
  { id: 14, countryId: 5, name: 'Pago Pago' },
  { id: 15, countryId: 7, name: 'Cabinda' },
  { id: 16, countryId: 7, name: 'Lobito' },
  { id: 17, countryId: 7, name: 'Luanda' },
  { id: 18, countryId: 7, name: 'Namibe' },
  { id: 19, countryId: 8, name: 'Blowing Point' },
  { id: 20, countryId: 8, name: 'Road Bay' },
  { id: 21, countryId: 10, name: "Saint John's" },
  { id: 22, countryId: 11, name: 'Bahia Blanca' },
  { id: 23, countryId: 11, name: 'Buenos Aires' },
  { id: 24, countryId: 11, name: 'La Plata' },
  { id: 25, countryId: 11, name: 'Punta Colorada' },
  { id: 26, countryId: 11, name: 'Ushuaia' },
  { id: 27, countryId: 13, name: 'Barcadera' },
  { id: 28, countryId: 13, name: 'Oranjestad' },
  { id: 29, countryId: 14, name: 'Brisbane' },
  { id: 30, countryId: 14, name: 'Cairns' },
  { id: 31, countryId: 14, name: 'Darwin' },
  { id: 32, countryId: 14, name: 'Fremantle' },
  { id: 33, countryId: 14, name: 'Geelong' },
  { id: 34, countryId: 14, name: 'Gladstone' },
  { id: 35, countryId: 14, name: 'Hobart' },
  { id: 36, countryId: 14, name: 'Melbourne' },
  { id: 37, countryId: 14, name: 'Newcastle' },
  { id: 38, countryId: 14, name: 'Port Adelaide' },
  { id: 39, countryId: 14, name: 'Port Kembla' },
  { id: 40, countryId: 14, name: 'Sydney' },
  { id: 41, countryId: 16, name: 'Baku (Baki)' },
  { id: 42, countryId: 17, name: 'Nassau' },
  { id: 43, countryId: 18, name: "Mina' Salman" },
  { id: 44, countryId: 19, name: 'Chittagong' },
  { id: 45, countryId: 20, name: 'Bridgetown' },
  { id: 46, countryId: 22, name: 'Oostende' },
  { id: 47, countryId: 22, name: 'Zeebrugge' },
  { id: 48, countryId: 22, name: 'Antwerp' },
  { id: 49, countryId: 23, name: 'Belize City' },
  { id: 50, countryId: 24, name: 'Cotonou' },
  { id: 51, countryId: 25, name: 'Hamilton' },
  { id: 52, countryId: 31, name: 'Paranagua' },
  { id: 53, countryId: 31, name: 'Rio de Janeiro' },
  { id: 54, countryId: 31, name: 'Santos' },
  { id: 55, countryId: 31, name: 'Itajai' },
  { id: 56, countryId: 32, name: 'Diego Garcia' },
  { id: 57, countryId: 239, name: 'Road Harbor' },
  { id: 58, countryId: 33, name: 'Muara' },
  { id: 59, countryId: 34, name: 'Burgas' },
  { id: 60, countryId: 34, name: 'Varna' },
  { id: 61, countryId: 40, name: 'Porto Grande' },
  { id: 62, countryId: 37, name: 'Sihanoukville (Kampong Saom)' },
  { id: 63, countryId: 39, name: 'Montreal' },
  { id: 64, countryId: 39, name: 'Vancouver' },
  { id: 65, countryId: 41, name: 'George Town' },
  { id: 66, countryId: 44, name: 'San Antonio' },
  { id: 67, countryId: 44, name: 'Coronel' },
  { id: 68, countryId: 44, name: 'Huasco' },
  { id: 69, countryId: 44, name: 'Lirquen' },
  { id: 70, countryId: 44, name: 'Puerto Ventanas' },
  { id: 71, countryId: 44, name: 'San Vicente' },
  { id: 72, countryId: 44, name: 'Valparaiso' },
  { id: 73, countryId: 45, name: 'Dalian' },
  { id: 74, countryId: 45, name: 'Guangzhou' },
  { id: 75, countryId: 45, name: 'Ningbo' },
  { id: 76, countryId: 45, name: 'Qingdao' },
  { id: 77, countryId: 45, name: 'Shanghai' },
  { id: 78, countryId: 45, name: 'Shenzhen' },
  { id: 79, countryId: 45, name: 'Tianjin' },
  { id: 80, countryId: 48, name: 'Cartagena' },
  { id: 81, countryId: 51, name: 'Banana' },
  { id: 82, countryId: 50, name: 'Pointe-Noire' },
  { id: 83, countryId: 53, name: 'Caldera' },
  { id: 84, countryId: 54, name: 'Abidjan' },
  { id: 85, countryId: 55, name: 'Ploce' },
  { id: 86, countryId: 55, name: 'Rijeka' },
  { id: 87, countryId: 55, name: 'Sibernik' },
  { id: 88, countryId: 55, name: 'Split' },
  { id: 89, countryId: 56, name: 'Guantanamo' },
  { id: 90, countryId: 56, name: 'Havana' },
  { id: 91, countryId: 57, name: 'Larnaca' },
  { id: 92, countryId: 59, name: 'Aarhus' },
  { id: 93, countryId: 59, name: 'Copenhagen' },
  { id: 94, countryId: 59, name: 'Fredericia' },
  { id: 95, countryId: 59, name: 'Kalundborg' },
  { id: 96, countryId: 59, name: 'Esbjerg' },
  { id: 97, countryId: 61, name: 'Portsmouth' },
  { id: 98, countryId: 62, name: 'Santo Domingo' },
  { id: 99, countryId: 63, name: 'Guayaquil' },
  { id: 100, countryId: 64, name: 'Alexandria' },
  { id: 101, countryId: 64, name: 'Suez' },
  { id: 102, countryId: 64, name: 'Port Said' },
  { id: 103, countryId: 65, name: 'Puerto Cutuco' },
  { id: 104, countryId: 66, name: 'Malabo' },
  { id: 105, countryId: 67, name: 'Massawa' },
  { id: 106, countryId: 68, name: 'Tallinn' },
  { id: 107, countryId: 70, name: 'Stanley' },
  { id: 108, countryId: 71, name: 'Fuglafjordur' },
  { id: 109, countryId: 71, name: 'Torshavn' },
  { id: 110, countryId: 71, name: 'Vagur' },
  { id: 111, countryId: 72, name: 'Lautoka' },
  { id: 112, countryId: 73, name: 'Helsinki' },
  { id: 113, countryId: 74, name: 'Le Havre' },
  { id: 114, countryId: 74, name: 'Marseille' },
  { id: 115, countryId: 76, name: 'Papeete' },
  { id: 116, countryId: 78, name: 'Libreville' },
  { id: 117, countryId: 79, name: 'Banjul' },
  { id: 118, countryId: 80, name: "Bat'umi" },
  { id: 119, countryId: 81, name: 'Bremen/Bremerhaven' },
  { id: 120, countryId: 81, name: 'Hamburg' },
  { id: 121, countryId: 82, name: 'Takoradi' },
  { id: 122, countryId: 83, name: 'Gibraltar' },
  { id: 123, countryId: 84, name: 'Thessaloniki' },
  { id: 124, countryId: 85, name: 'Sisimiut' },
  { id: 125, countryId: 86, name: "Saint George's" },
  { id: 126, countryId: 88, name: 'Apra Harbor' },
  { id: 127, countryId: 89, name: 'Puerto Quetzal' },
  { id: 128, countryId: 90, name: 'Braye Bay' },
  { id: 129, countryId: 92, name: 'Bissau' },
  { id: 130, countryId: 91, name: 'Conakry' },
  { id: 131, countryId: 93, name: 'Georgetown' },
  { id: 132, countryId: 94, name: 'Cap-Haitien' },
  { id: 133, countryId: 97, name: 'San Lorenzo' },
  { id: 134, countryId: 98, name: 'Hong Kong' },
  { id: 135, countryId: 100, name: 'Grundartangi' },
  { id: 136, countryId: 100, name: 'Hafnarfjordur' },
  { id: 137, countryId: 100, name: 'Reykjavik' },
  { id: 138, countryId: 101, name: 'Chennai' },
  { id: 139, countryId: 101, name: 'Jawaharal Nehru Port' },
  { id: 140, countryId: 102, name: 'Tanjung Priok' },
  { id: 141, countryId: 103, name: 'Bandar Abbas' },
  { id: 142, countryId: 105, name: 'Dublin' },
  { id: 143, countryId: 106, name: 'Douglas' },
  { id: 144, countryId: 107, name: 'Ashdod' },
  { id: 145, countryId: 107, name: 'Haifa' },
  { id: 146, countryId: 108, name: 'Genoa' },
  { id: 147, countryId: 108, name: 'Gioia Tauro' },
  { id: 148, countryId: 108, name: 'La Spezia' },
  { id: 149, countryId: 109, name: 'Kingston' },
  { id: 150, countryId: 110, name: 'Kobe' },
  { id: 151, countryId: 110, name: 'Nagoya' },
  { id: 152, countryId: 110, name: 'Osaka' },
  { id: 153, countryId: 110, name: 'Tokyo' },
  { id: 154, countryId: 110, name: 'Yokohama' },
  { id: 155, countryId: 111, name: 'Gorey' },
  { id: 156, countryId: 112, name: "Al 'Aqabah" },
  { id: 157, countryId: 114, name: 'Kisumu' },
  { id: 158, countryId: 114, name: 'Mombasa' },
  { id: 159, countryId: 115, name: 'Betio (Tarawa Atoll)' },
  { id: 160, countryId: 116, name: 'Busan' },
  { id: 161, countryId: 116, name: 'Kwangyang' },
  { id: 162, countryId: 116, name: 'Incheon' },
  { id: 163, countryId: 117, name: "Ash Shu'aybah" },
  { id: 164, countryId: 120, name: 'Riga' },
  { id: 165, countryId: 121, name: 'Beirut' },
  { id: 166, countryId: 121, name: 'Tripoli' },
  { id: 167, countryId: 123, name: 'Buchanan' },
  { id: 168, countryId: 123, name: 'Monrovia' },
  { id: 169, countryId: 124, name: 'Tripoli' },
  { id: 170, countryId: 126, name: 'Klaipeda' },
  { id: 171, countryId: 128, name: 'Macau' },
  { id: 172, countryId: 130, name: 'Antsiranana (Diego Suarez)' },
  { id: 173, countryId: 132, name: 'George Town (Penang)' },
  { id: 174, countryId: 132, name: 'Port Kelang (Port Klang)' },
  { id: 175, countryId: 132, name: 'Tanjung Pelepas' },
  { id: 176, countryId: 133, name: 'Male' },
  { id: 177, countryId: 135, name: 'Marsaxlokk' },
  { id: 178, countryId: 136, name: 'Enitwetak Island' },
  { id: 179, countryId: 138, name: 'Nouadhibou' },
  { id: 180, countryId: 139, name: 'Port Louis' },
  { id: 181, countryId: 141, name: 'Manzanillo' },
  { id: 182, countryId: 141, name: 'Lazaro Cardenas' },
  { id: 183, countryId: 142, name: 'Colonia (Tomil Harbor)' },
  { id: 184, countryId: 144, name: 'Monaco' },
  { id: 185, countryId: 146, name: 'Bar' },
  { id: 186, countryId: 147, name: 'Little Bay' },
  { id: 187, countryId: 148, name: 'Tangier' },
  { id: 188, countryId: 149, name: 'Beira' },
  { id: 189, countryId: 151, name: 'Luderitz' },
  { id: 190, countryId: 152, name: 'Nauru' },
  { id: 191, countryId: 154, name: 'Rotterdam' },
  { id: 192, countryId: 156, name: 'Noumea' },
  { id: 193, countryId: 157, name: 'Auckland' },
  { id: 194, countryId: 157, name: 'Wellington' },
  { id: 195, countryId: 158, name: 'Bluefields' },
  { id: 196, countryId: 160, name: 'Lagos' },
  { id: 197, countryId: 161, name: 'Alofi' },
  { id: 198, countryId: 162, name: 'Kingston' },
  { id: 199, countryId: 163, name: 'Saipan' },
  { id: 200, countryId: 164, name: 'Bergen' },
  { id: 201, countryId: 164, name: 'Haugesund' },
  { id: 202, countryId: 164, name: 'Maaloy' },
  { id: 203, countryId: 164, name: 'Mongstad' },
  { id: 204, countryId: 164, name: 'Narvik' },
  { id: 205, countryId: 164, name: 'Sture' },
  { id: 206, countryId: 165, name: 'Salalah' },
  { id: 207, countryId: 166, name: 'Karachi' },
  { id: 208, countryId: 169, name: 'Balboa' },
  { id: 209, countryId: 169, name: 'Colon' },
  { id: 210, countryId: 169, name: 'Manzanillo' },
  { id: 211, countryId: 170, name: 'Kimbe' },
  { id: 212, countryId: 172, name: 'Callao' },
  { id: 213, countryId: 173, name: 'Manila' },
  { id: 214, countryId: 174, name: 'Adamstown' },
  { id: 215, countryId: 175, name: 'Gdansk' },
  { id: 216, countryId: 175, name: 'Gdynia' },
  { id: 217, countryId: 175, name: 'Swinoujscie' },
  { id: 218, countryId: 176, name: 'Lisbon' },
  { id: 219, countryId: 177, name: 'San Juan' },
  { id: 220, countryId: 178, name: 'Doha' },
  { id: 221, countryId: 180, name: 'Constanta' },
  { id: 222, countryId: 180, name: 'Midia' },
  { id: 223, countryId: 181, name: 'Kaliningrad' },
  { id: 224, countryId: 181, name: 'Nakhodka' },
  { id: 225, countryId: 181, name: 'Novorossiysk' },
  { id: 226, countryId: 181, name: 'Primorsk' },
  { id: 227, countryId: 181, name: 'Vostochnyy' },
  { id: 228, countryId: 181, name: 'Saint Petersburg' },
  { id: 229, countryId: 183, name: 'Gustavia' },
  { id: 230, countryId: 184, name: 'Jamestown' },
  { id: 231, countryId: 184, name: 'Georgetown' },
  { id: 232, countryId: 184, name: 'Calshot Harbor (Edinburgh)' },
  { id: 233, countryId: 185, name: 'Basseterre' },
  { id: 234, countryId: 185, name: 'Charlestown' },
  { id: 235, countryId: 186, name: 'Castries' },
  { id: 236, countryId: 188, name: 'Saint-Pierre' },
  { id: 237, countryId: 189, name: 'Kingstown' },
  { id: 238, countryId: 190, name: 'Apia' },
  { id: 239, countryId: 192, name: 'Sao Tome' },
  { id: 240, countryId: 193, name: 'Ad Dammam' },
  { id: 241, countryId: 193, name: 'Jeddah' },
  { id: 242, countryId: 194, name: 'Dakar' },
  { id: 243, countryId: 196, name: 'Victoria' },
  { id: 244, countryId: 197, name: 'Freetown' },
  { id: 245, countryId: 198, name: 'Singapore' },
  { id: 246, countryId: 187, name: 'Philipsburg' },
  { id: 247, countryId: 200, name: 'Koper' },
  { id: 248, countryId: 201, name: 'Honiara' },
  { id: 249, countryId: 202, name: 'Berbera' },
  { id: 250, countryId: 203, name: 'Cape Town' },
  { id: 251, countryId: 203, name: 'Durban' },
  { id: 252, countryId: 204, name: 'Grytviken' },
  { id: 253, countryId: 205, name: 'Algeciras' },
  { id: 254, countryId: 205, name: 'Barcelona' },
  { id: 255, countryId: 205, name: 'Valencia' },
  { id: 256, countryId: 205, name: 'Las Palmas' },
  { id: 257, countryId: 206, name: 'Colombo' },
  { id: 258, countryId: 207, name: 'Port Sudan' },
  { id: 259, countryId: 208, name: 'Paramaribo' },
  { id: 260, countryId: 209, name: 'Barentsburg' },
  { id: 261, countryId: 209, name: 'Longyearbyen' },
  { id: 262, countryId: 209, name: 'Ny-Alesund' },
  { id: 263, countryId: 209, name: 'Pyramiden' },
  { id: 264, countryId: 211, name: 'Brofjorden' },
  { id: 265, countryId: 211, name: 'Goteborg' },
  { id: 266, countryId: 211, name: 'Helsingborg' },
  { id: 267, countryId: 211, name: 'Karlshamn' },
  { id: 268, countryId: 211, name: 'Lulea' },
  { id: 269, countryId: 211, name: 'Malmo' },
  { id: 270, countryId: 211, name: 'Stockholm' },
  { id: 271, countryId: 211, name: 'Trelleborg' },
  { id: 272, countryId: 211, name: 'Visby' },
  { id: 273, countryId: 213, name: 'Baniyas' },
  { id: 274, countryId: 214, name: 'Chilung (Keelung)' },
  { id: 275, countryId: 214, name: 'Kaohsiung' },
  { id: 276, countryId: 214, name: 'Taichung' },
  { id: 277, countryId: 216, name: 'Zanzibar' },
  { id: 278, countryId: 217, name: 'Bangkok' },
  { id: 279, countryId: 217, name: 'Laem Chabang' },
  { id: 280, countryId: 218, name: 'Dili' },
  { id: 281, countryId: 219, name: 'Kpeme' },
  { id: 282, countryId: 221, name: "Nuku'alofa" },
  { id: 283, countryId: 222, name: 'Point Fortin' },
  { id: 284, countryId: 223, name: 'Bizerte' },
  { id: 285, countryId: 224, name: 'Ambarli' },
  { id: 286, countryId: 224, name: 'Mersin (Icel)' },
  { id: 287, countryId: 225, name: 'Turkmenbasy' },
  { id: 288, countryId: 226, name: 'Cockburn Harbour' },
  { id: 289, countryId: 227, name: 'Funafuti' },
  { id: 290, countryId: 229, name: 'Feodosiya (Theodosia)' },
  { id: 291, countryId: 229, name: 'Illichivsk' },
  { id: 292, countryId: 229, name: 'Mariupol' },
  { id: 293, countryId: 229, name: 'Mykolayiv' },
  { id: 294, countryId: 229, name: 'Odesa' },
  { id: 295, countryId: 229, name: 'Yuzhnyy' },
  { id: 296, countryId: 230, name: 'Dubai Port' },
  { id: 297, countryId: 230, name: 'Khor Fakkan (Khawr Fakkan)' },
  { id: 298, countryId: 231, name: 'Felixstowe' },
  { id: 299, countryId: 231, name: 'London' },
  { id: 300, countryId: 231, name: 'Southampton' },
  { id: 301, countryId: 233, name: 'Sand Island' },
  { id: 302, countryId: 232, name: 'Hampton Roads' },
  { id: 303, countryId: 232, name: 'Houston' },
  { id: 304, countryId: 232, name: 'Long Beach' },
  { id: 305, countryId: 232, name: 'Los Angeles' },
  { id: 306, countryId: 232, name: 'New York/New Jersey' },
  { id: 307, countryId: 232, name: 'Oakland' },
  { id: 308, countryId: 232, name: 'Savannah' },
  { id: 309, countryId: 232, name: 'Seattle' },
  { id: 310, countryId: 234, name: 'Montevideo' },
  { id: 311, countryId: 236, name: 'Forari Bay' },
  { id: 312, countryId: 237, name: 'La Guaira' },
  { id: 313, countryId: 238, name: 'Haiphong' },
  { id: 314, countryId: 238, name: 'Saigon New Port' },
  { id: 315, countryId: 240, name: 'Charlotte Amalie' },
  { id: 316, countryId: 240, name: 'Christiansted' },
  { id: 317, countryId: 240, name: 'Cruz Bay' },
  { id: 318, countryId: 240, name: 'Frederiksted' },
  { id: 319, countryId: 240, name: 'Limetree Bay' },
  { id: 320, countryId: 241, name: 'Leava' },
  { id: 321, countryId: 242, name: 'Ad Dakhla' },
  { id: 322, countryId: 243, name: 'Aden' },
]
